module.exports = __webpack_public_path__ + "img/logoK9corp.e45ba83f.png";